// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1pPEL","label":"Labeled_label__3J-TC","divider":"Labeled_divider__1hbQC"};